import LegalShell, { LegalSection } from "../components/LegalShell";
import { Mail, Shield } from "lucide-react";

export default function Contact() {
  return (
    <LegalShell eyebrow="We're here to help" title="Contact & Support">
      <div className="rounded-3xl bg-[rgba(157,0,255,0.14)] border border-blue-100 p-7 not-prose">
        <div className="flex items-start gap-4">
          <span className="grid place-items-center w-12 h-12 rounded-2xl bg-[rgba(128,255,234,0.14)] border border-[rgba(128,255,234,0.3)] text-[#80FFEA] shrink-0">
            <Mail size={22} />
          </span>
          <div>
            <div className="font-display font-bold text-xl text-white">Email Cavilow Support</div>
            <p className="text-sm text-slate-300 mt-1 leading-relaxed">
              For support, privacy requests, or account-related help, contact us at:
            </p>
            <a
              href="mailto:contactcavilow@gmail.com"
              className="mt-3 inline-flex items-center gap-2 rounded-xl bg-[var(--cavilo-blue)] hover:bg-[var(--cavilo-blue-deep)] text-white px-5 py-2.5 text-sm font-bold transition-colors btn-press"
              data-testid="contact-email-link"
            >
              <Mail size={14} /> contactcavilow@gmail.com
            </a>
          </div>
        </div>
      </div>

      <LegalSection title="What we can help with">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Account access, login or password issues.</li>
          <li>Subscription, billing, or refund questions.</li>
          <li>Privacy requests — data export or full account deletion.</li>
          <li>Bug reports and feature requests.</li>
          <li>Anything else about your Cavilow experience.</li>
        </ul>
      </LegalSection>

      <LegalSection title="Response time">
        <p>
          We aim to respond within 1–2 business days. Privacy and account-deletion requests are prioritised.
        </p>
      </LegalSection>

      <div className="flex items-center gap-2 text-xs text-slate-400">
        <Shield size={14} className="text-emerald-500" />
        Your messages are handled by the Cavilow team only.
      </div>
    </LegalShell>
  );
}
